import * as tslib_1 from "tslib";
import { OnInit, EventEmitter } from '@angular/core';
import { Data } from './services/data';
import { MetabolismCalculator } from './services/metabolism';
import { MetabolismGender } from './services/database';
var TargetsComponent = /** @class */ (function () {
    function TargetsComponent(data, meta) {
        var _this = this;
        this.data = data;
        this.meta = meta;
        this.MetabolismGender = MetabolismGender;
        this.hide = new EventEmitter();
        this.data.renderableChanges.subscribe(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () { return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, this.updateState()];
                case 1: return [2 /*return*/, _a.sent()];
            }
        }); }); });
    }
    TargetsComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var prefs;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.data.getUserPrefs()];
                    case 1:
                        prefs = _a.sent();
                        this.genderPref = prefs.metabolismGender;
                        return [4 /*yield*/, this.updateState()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    TargetsComponent.prototype.updateState = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var lastUser;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.data.getLatestUser()];
                    case 1:
                        lastUser = _a.sent();
                        if (!lastUser) {
                            return [2 /*return*/, console.error('unable to get last user')];
                        }
                        this.metabolicInfo = this.meta.getMetabolismInfo(lastUser, this.genderPref);
                        return [2 /*return*/];
                }
            });
        });
    };
    TargetsComponent.prototype.setGenderPrefs = function (ev) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var newValue, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        newValue = ev.value;
                        _a = this;
                        return [4 /*yield*/, this.data.setGenderPref(newValue)];
                    case 1:
                        _a.genderPref = _b.sent();
                        return [4 /*yield*/, this.updateState()];
                    case 2:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return TargetsComponent;
}());
export { TargetsComponent };
